"use strict";

exports.__esModule = true;
exports.viewProduct = exports.updatedSharedState = exports.setOnboardingResult = exports.resetNotifications = exports.removeWishlist = exports.clearWishlist = exports.clearSharedState = exports.clearOnboardingResult = exports.clearKitchenConfigurations = exports.addWishlist = exports.addKitchenConfiguration = exports.actionTypes = void 0;
var actionTypes = exports.actionTypes = {
  ADD_KITCHEN_CONFIGURATION: 'ADD_KITCHEN_CONFIGURATION',
  CLEAR_KITCHEN_CONFIGURATIONS: 'CLEAR_KITCHEN_CONFIGURATIONS',
  ADD_WISHLIST: 'ADD_WISHLIST',
  REMOVE_WISHLIST: 'REMOVE_WISHLIST',
  CLEAR_WISHLIST: 'CLEAR_WISHLIST',
  VIEW_PRODUCT: 'VIEW_PRODUCT',
  SET_ONBOARDING_RESULT: 'SET_ONBOARDING_RESULT',
  CLEAR_ONBOARDING_RESULT: 'CLEAR_ONBOARDING_RESULT',
  RESET_NOTIFICATIONS: 'RESET_NOTIFICATIONS',
  UPDATED_SHARED_STATE: 'UPDATED_SHARED_STATE'
};

// Wishlist
var addWishlist = exports.addWishlist = function addWishlist(product) {
  return {
    type: actionTypes.ADD_WISHLIST,
    product: Object.assign({}, product, {
      favoritedAt: new Date().toISOString()
    })
  };
};
var removeWishlist = exports.removeWishlist = function removeWishlist(productId) {
  return {
    type: actionTypes.REMOVE_WISHLIST,
    productId: productId
  };
};
var clearWishlist = exports.clearWishlist = function clearWishlist() {
  return {
    type: actionTypes.CLEAR_WISHLIST
  };
};

// Latest viewed products
var viewProduct = exports.viewProduct = function viewProduct(product) {
  return {
    type: actionTypes.VIEW_PRODUCT,
    product: product
  };
};

// Kitchen Configurations
var addKitchenConfiguration = exports.addKitchenConfiguration = function addKitchenConfiguration(kitchenRangeName, config) {
  return {
    type: actionTypes.ADD_KITCHEN_CONFIGURATION,
    kitchenRangeName: kitchenRangeName,
    config: Object.assign({}, config, {
      createdAt: new Date().toISOString()
    })
  };
};
var clearKitchenConfigurations = exports.clearKitchenConfigurations = function clearKitchenConfigurations() {
  return {
    type: actionTypes.CLEAR_KITCHEN_CONFIGURATIONS
  };
};

// Onboarding result
var setOnboardingResult = exports.setOnboardingResult = function setOnboardingResult(result) {
  return {
    type: actionTypes.SET_ONBOARDING_RESULT,
    result: Object.assign({}, result, {
      createdAt: new Date().toISOString()
    })
  };
};
var clearOnboardingResult = exports.clearOnboardingResult = function clearOnboardingResult() {
  return {
    type: actionTypes.CLEAR_ONBOARDING_RESULT
  };
};

// Notification state

var resetNotifications = exports.resetNotifications = function resetNotifications() {
  return {
    type: actionTypes.RESET_NOTIFICATIONS
  };
};
var updatedSharedState = exports.updatedSharedState = function updatedSharedState(source) {
  return {
    type: actionTypes.UPDATED_SHARED_STATE,
    source: source
  };
};

// Reset all shared state

var clearSharedState = exports.clearSharedState = function clearSharedState() {
  return function (dispatch) {
    dispatch(clearKitchenConfigurations);
    dispatch(clearOnboardingResult);
    dispatch(clearWishlist);
    dispatch(resetNotifications);
  };
};